import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { useEnrollments } from './use-enrollments';

/**
 * Note: It's unlikely that a user will land on a program page if they're enrolled in the program.
 * But if they do we should redirect them to the enrollment page
 */
export function useEnrollmentRedirect(programKey: string) {
  const router = useRouter();
  const { enrollment } = useEnrollments(programKey);
  useEffect(() => {
    if (enrollment) {
      router.replace(`/enrollment/${programKey}`);
    }
  }, [enrollment, programKey, router]);
}
